<template>
  <div>
    <Boyo-Dialog :dialogInfo="dialogInfoData" @dialogEvent="dialogEventData">
      <div style="display: flex; flex-direction: row; align-items: flex-start;">
        <!-- 审批步骤 -->
        <div style="width: 240px; min-width: 240px; margin-right: 24px;">
          <el-steps direction="vertical" :active="activeValue">
            <el-step v-for="(item, index) in activeList" :key="index" :title="item.processNodeName" :status="item.stepStatus || 'process'">
              <template #description>
                <div v-if="item.processNodeName === '制单人'">
                  {{ item.approvalTime }}
                </div>
                <div v-else>
                  <div style="border-top: 1px solid #e4e7ed; margin: 8px 0;"></div>
                  <div>流程节点：{{ item.processNodeName || '' }}</div>
                  <div>经办人：{{ item.maker || '' }}</div>
                  <div v-if="item.stepStatus !== 'process'">备注：{{ item.remark || (item.stepStatus === 'success' ? '通过' : '拒绝') }}</div>
                  <div>时间：{{ item.makerTime || '' }}</div>
                </div>
              </template>
            </el-step>
          </el-steps>
        </div>
        <!-- 详情 -->
        <div style="flex: 1; overflow-x: auto;">
          <Boyo-Formtwo
            :formInfo="formInfo2"
            :refObj.sync="formInfo2.ref"
            :listTypeInfo="listTypeInfo"
          />
          <!-- 审核表单 -->
          <div v-if="showAuditDataFields" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
            <div class="quick-phrase-area">
              <div class="quick-phrase-label">常用快捷短语:</div>
              <div class="quick-phrase-buttons">
                <el-button
                  v-for="(phrase, index) in quickPhrases"
                  :key="index"
                  size="mini"
                  @click="insertQuickPhrase(phrase)"
                  class="phrase-btn"
                >
                  {{ phrase }}
                </el-button>
              </div>
            </div>
            <Boyo-Formtwo
              :formInfo="formInfoAuditData"
              :refObj.sync="formInfoAuditData.ref"
              :listTypeInfo="listTypeInfo"
            />
          </div>
        </div>
      </div>
    </Boyo-Dialog>
  </div>
</template>

<script>
import BoyoDialog from '@/components/BoyoDialog'
import BoyoFormtwo from '@/components/BoyoFormtwo'

export default {
  name: 'PurchaseHeavyVehiclesDialog',
  components: {
    BoyoDialog,
    BoyoFormtwo
  },
  data() {
    return {
      activeValue: null,
      activeList: [],
      billId: '',
      dataId: '',
      maker: '无',
      makerTime: '',
      detailDate: {},
      auditParm: {},
      showAuditDataFields: false,
      quickPhrases: ['同意', '不同意', '请补充附件', '报价单'],
      listTypeInfo: {
        statusFlag2: [
          { value: 1, label: '同意' },
          { value: 2, label: '不同意' }
        ],
        saleModeList: [
          { label: '车', value: 0 },
          { label: '船', value: 1 }
        ],
        deliveryModeList: [
          { label: '自提', value: 0 },
          { label: '送到', value: 1 }
        ],
        meterTypeList: [
          { label: '不过磅', value: 0 },
          { label: '我方磅重', value: 1 },
          { label: '对方磅重', value: 2 },
          { label: '仅过磅核对', value: 3 }
        ],
        processId: []
      },
      dialogInfoData: {
        visible: false,
        width: '1200px',
        title: {
          add: '提货单空车出场对应数据'
        },
        type: 'add',
        btList: [
          { label: '审核', type: 'success', icon: '', event: 'save', loading: false, show: false },
          { label: '关闭', type: '', icon: '', event: 'close', loading: false }
        ]
      },
      formInfo2: {
        ref: null,
        labelWidth: '90px',
        inline: true,
        data: {
          id: null,
          carNo: '',
        //   partnerId: null,
          partnerName: '',
          driver: '',
          material: '',
          carGrossWeight: '',
          carTareWeight: '',
          carNetWeight: '',
          contractNumber: '',
          heavyCarOutRemark: '',
        },
        list: [
          { type: 'text', label: '合同号：', value: 'contractNumber', style: 'width:95%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '车号：', value: 'carNo', style: 'width:95%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '供应商：', value: 'partnerName', style: 'width:95%', className: 'form_item_two', disabled: true },
        //   { type: 'select计量标准：', label: '计量标准：', value: 'meterType', style: 'width:95%', className: 'form_item_two', list: 'meterTypeList', disabled: true },
          { type: 'text', label: '司机：', value: 'driver', style: 'width:95%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '商品：', value: 'material', style: 'width:95%', className: 'form_item_two', disabled: true },
          { type: 'number', label: '毛重/吨：', value: 'carGrossWeight', style: 'width:95%', className: 'form_item_two', disabled: true },
        //   { type: 'number', label: '皮重：', value: 'carTareWeight', style: 'width:95%', className: 'form_item_two', disabled: true },
        //   { type: 'number', label: '净重：', value: 'carNetWeight', style: 'width:95%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '重车原因：', value: 'heavyCarOutRemark', style: 'width:95%', className: 'form_item_two', disabled: true }
        ],
        rules: {}
      },
      formInfoAuditData: {
        ref: null,
        labelWidth: '100px',
        data: {
          id: '',
          processId: '',
          remark: '',
          status: ''
        },
        list: [
          { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%', disabled: true },
          { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one', list: 'statusFlag2', unclearable: true },
          { type: 'text', label: '备注：', value: 'remark', style: 'width:80%' }
        ],
        rules: {
          status: [{ required: true, trigger: 'change', message: '请选择' }]
        }
      }
    }
  },
  methods: {
    dialogShow(data, val, parm, id, maker, makerTime) {
      this.billId = data
      this.dataId = id
      this.maker = maker || '无'
      this.makerTime = makerTime || ''

      if (parm && parm.id) {
        this.auditParm = parm
        this.dialogInfoData.btList[0].show = true
        this.showAuditDataFields = true

        this.$nextTick(() => {
          for (const key in this.formInfoAuditData.data) {
            this.formInfoAuditData.data[key] = ''
          }
          this.loadProcessEnum().then(() => {
            let processFound = false
            for (const item of this.listTypeInfo.processId) {
              if (parm.processId === item.enumValue) {
                this.formInfoAuditData.data.processId = item.value
                processFound = true
                break
              }
            }
            if (!processFound) {
              console.warn('未找到匹配的流程ID:', parm.processId, '可用流程:', this.listTypeInfo.processId)
              this.formInfoAuditData.data.processId = parm.processId
            }
            this.formInfoAuditData.data.status = 1
          })
        })
      } else {
        this.dialogInfoData.btList[0].show = false
        this.showAuditDataFields = false
      }

      this.getInfo(val)
    },
    loadProcessEnum() {
      return new Promise(resolve => {
        if (this.listTypeInfo.processId && this.listTypeInfo.processId.length > 0) {
          resolve()
          return
        }
        this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
          if (res.code === 0) {
            this.listTypeInfo.processId = res.data.list.map(item => ({value: item.processId, enumValue: item.processCode, label: item.name}))
          }
          resolve()
        }).catch(() => resolve())
      })
    },
    getInfo(val) {
      // 审批步骤
      this.$api.system.getActProcessEntryPage({ idProcessInstance: this.dataId, pageNum: 1, pageSize: 999 }).then(res => {
        if (res.code === 0) {
          this.activeList = []
          this.activeValue = 0
          res.data.list.forEach((item, idx) => {
            if (item.status && idx < res.data.list.length) {
              this.activeValue = Number(idx + 1)
            }
            let stepStatus = 'process'
            if (item.status === 1) stepStatus = 'success'
            else if (item.status === 2) stepStatus = 'error'
            this.activeList.push({
              processNodeName: item.processNodeName || '',
              maker: item.status ? item.actualApprover : (item.approver ? item.approver : item.roleName),
              remark: item.remark || '',
              makerTime: item.approvalTime || '',
              stepStatus
            })
          })
          const approvalTime = this.maker + (this.makerTime ? (' ' + this.makerTime) : '')
          this.activeList.unshift({ processNodeName: '制单人', approvalTime })
          this.activeValue = (this.activeValue || 0) + 1
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
      })

      // 报价单主表
      this.$api.OrderPurchase.getPurArrivalPage({ id: this.billId }).then(res => {
        if (res.code === 0 && res.data.list.length > 0) {
          const q = res.data.list[0]
          this.detailDate = q
          for (let key in this.formInfo2.data) {
                this.formInfo2.data[key] = ''
            }
            for (let key in this.detailDate) {
                if (key in this.formInfo2.data) {
                    this.formInfo2.data[key] = this.detailDate[key];
                }
            }
            this.dialogInfoData.visible = true
        } else {
          this.$message({ message: res.msg || '提货单不存在', type: 'warning' })
        }
      })
      
    },
    dialogEventData(event) {
      const dialogInfoData = this.dialogInfoData
      switch (event) {
        case 'save':
          this.formInfoAuditData.ref.validate(valid => {
            if (!valid) return
            const parma = {
              id: this.auditParm.id,
              processId: this.formInfoAuditData.data.processId,
              status: this.formInfoAuditData.data.status,
              remark: this.formInfoAuditData.data.remark
            }
            dialogInfoData.btList[0].loading = true
            this.$api.system.approval(parma).then(res => {
              dialogInfoData.btList[0].loading = false
              if (res.code === 0) {
                this.$message({ message: res.msg, type: 'success' })
                dialogInfoData.visible = false
                this.$emit('approvalInfo')
              } else {
                this.$message({ message: res.msg, type: 'error' })
              }
            }).catch(() => {
              dialogInfoData.btList[0].loading = false
            })
          })
          break
        case 'close':
          dialogInfoData.visible = false
          break
      }
    },
    insertQuickPhrase(phrase) {
      const currentRemark = this.formInfoAuditData.data.remark || ''
      this.formInfoAuditData.data.remark = currentRemark ? (currentRemark + ' ' + phrase) : phrase
    }
  }
}
</script>

<style scoped>
.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}
.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}
.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.phrase-btn {
  margin: 0;
  white-space: nowrap;
}
</style>




// WEBPACK FOOTER //
// src/components/Custom/PurchaseHeavyVehiclesDialog.vue